import { Injectable } from '@angular/core';

import { IntegrationsApiService } from '@recruitee/integrations/http';

@Injectable({ providedIn: 'root' })
export class XingApiService extends IntegrationsApiService {
  public context: string = 'xing';
}
